import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import {MatDialog, MatDialogConfig} from '@angular/material/dialog';

import { Plan } from '../../../models/plan.model';
import { AppState } from '../../../app.reducer';
import { ProductCar } from '../../../models/productCar.model';
import { removeToCar } from '../../../redux/actions/carCheckout.actions';
import { removePlanFromCar } from '../../../redux/actions/carPlanCheckout.actions';
import { ProductsService } from '../../../services/products/products.service';
import { HttpErrorResponse } from '@angular/common/http';
import { ShoppingDialogComponent } from 'src/app/commons/shopping-dialog/shopping-dialog.component';
import { DataLayerService } from '../../../services/dataLayer/data-layer.service';

@Component({
  selector: 'app-resume',
  templateUrl: './resume.component.html',
  styleUrls: ['./resume.component.scss']
})
export class ResumeComponent implements OnInit {

  toogle: boolean = false;
  planSelected: Plan[] = [];
  aditionalProducts: ProductCar[] = [];
  summary!: number;
  summaryPlan: number = 0;
  dialogRef: any;

  constructor(
    private store: Store<AppState>,
    private router: Router,
    private productsService: ProductsService,
    public dialog: MatDialog,
    private dataLayerService: DataLayerService
  ) { }

  ngOnInit(): void {

    this.store.select('carPlanCheckout').subscribe(plan => {
      this.planSelected = [];
      this.summary = 0;
      let carCheckout = {};
      if (localStorage.getItem('__app_storage__') != null ) { 
        carCheckout = JSON.parse(localStorage.getItem("__app_storage__")).carCheckout;
      }
      let price = 0
      if(carCheckout != null) {
        for(let i in carCheckout) {
          price += carCheckout[i].priceDiscount;
        }
      }
      plan.forEach(item => {
        this.planSelected.push(item);
        this.summaryPlan = item.priceDiscount;
        this.summary = this.summary + this.summaryPlan + price;
      });
    });
    this.store.select('carCheckout').subscribe(product => {
      this.aditionalProducts = product;
      this.summary = 0 + this.summaryPlan;
      product.forEach(item => {
        this.summary = this.summary + item.totalPrice;
      });
    });
    
  }

  async removeplan() {
    this.planSelected.forEach(plan => {
      this.dataLayerService.pushTagByEventCar(plan, 'removeFromCart', 'remove', 1);
      this.store.dispatch(removePlanFromCar({ id: plan.id }))
    });
    this.aditionalProducts.forEach(product => this.store.dispatch(removeToCar({ id: product.id })));
    this.router.navigateByUrl('/');
  }

  async remove(index: number, quantity: number) {
    this.dataLayerService.pushTagByEventCar(this.aditionalProducts[index], 'removeFromCart', 'remove', quantity);
    this.store.dispatch(removeToCar({ id: this.aditionalProducts[index].id }))
  }

  openShoppingDialog = (): void => {
    const shoppingConfig = new MatDialogConfig();
    shoppingConfig.panelClass = 'shopping-modal';
    shoppingConfig.backdropClass = 'shopping-backdrop';
    this.dialog.open(ShoppingDialogComponent, shoppingConfig);
  }

}
